"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BenutzerStatus = function () {
  function BenutzerStatus() {}
  BenutzerStatus.STATUS_ANWESEND = '1';
  BenutzerStatus.STATUS_ABWESEND = '2';
  BenutzerStatus.STATUS_NA = '3';
  BenutzerStatus.STATUS_URLAUB = '4';
  BenutzerStatus.STATUS_HEIMARBEIT = '5';
  BenutzerStatus.STATUS_SEMINAR = '6';
  return BenutzerStatus;
}();
exports.BenutzerStatus = BenutzerStatus;